import React from 'react';
import { Link } from 'react-router-dom';
import { ABOUT_CONTENT, STATS } from '../constants';

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="hero" style={{ padding: '150px 2rem 80px' }}>
        <h1>About Us</h1>
        <p>IT Solutions & Consulting</p>
      </section>

      {/* About Content */}
      <section>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
              {ABOUT_CONTENT.intro}
            </p>
            <p style={{ fontSize: '1.15rem', marginBottom: '2rem' }}>
              {ABOUT_CONTENT.paragraph1}
            </p>
            <p style={{ fontSize: '1.15rem', marginBottom: '3rem' }}>
              {ABOUT_CONTENT.paragraph2}
            </p>
            
            <div className="grid grid-2" style={{ gap: '3rem', marginTop: '4rem' }}>
              <div className="card">
                <h3>{ABOUT_CONTENT.mission.title}</h3>
                <p>{ABOUT_CONTENT.mission.text}</p>
              </div>
              <div className="card">
                <h3>{ABOUT_CONTENT.vision.title}</h3>
                <p>{ABOUT_CONTENT.vision.text}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <section style={{ backgroundColor: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-header">
            <h2>{ABOUT_CONTENT.offerings.title}</h2>
          </div>
          <div className="grid grid-3">
            {ABOUT_CONTENT.offerings.items.map((item, index) => (
              <div key={index} className="card">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="stats-grid">
          {STATS.map((stat, index) => (
            <div key={index} className="stat-item">
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--primary-color)', color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: 'white' }}>Want to Work Together?</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.2rem', marginBottom: '2rem' }}>
            Let's talk about your challenges and see if we're a good fit.
          </p>
          <Link to="/contact" className="btn" style={{ backgroundColor: 'white', color: 'var(--primary-color)' }}>
            Get in Touch
          </Link>
        </div>
      </section>
    </div>
  );
}

export default About;